// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vg-8";
export var editMode = "_vg-3";
export var headerRow = "_vg-a";
export var headerTitle = "_vg-b";
export var product = "_vg-1";
export var productDetails = "_vg-5";
export var productDivider = "_vg-7";
export var productImage = "_vg-2";
export var productInfo = "_vg-4";
export var productTitle = "_vg-6";
export var strikethrough = "_vg-9";
export var upsellProductsCard = "_vg-0";